import React from 'react';
import { ShoppingBag, Package, ShoppingCart, BookOpen } from 'lucide-react';
import OrdersSummary from './OrdersSummary';

export default function PlatformSelector({ onSelectPlatform }) {
  const platforms = [
    {
      id: 'amazon',
      name: 'Amazon',
      icon: Package,
      color: 'from-orange-500 to-yellow-500',
      description: 'FBM & FBA Stores',
    },
    {
      id: 'shopify',
      name: 'Shopify',
      icon: ShoppingBag,
      color: 'from-green-500 to-emerald-500',
      description: 'E-commerce Store',
    },
    {
      id: 'ebay',
      name: 'eBay',
      icon: ShoppingCart,
      color: 'from-blue-500 to-indigo-500',
      description: 'Marketplace Stores',
    },
    // {
    //   id: 'ledger',
    //   name: 'Ledger',
    //   icon: BookOpen,
    //   color: 'from-purple-500 to-pink-500',
    //   description: 'Accounting & Finance',
    // },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-purple-900 to-blue-900">
      <div className="flex flex-col items-center p-4 pb-16">

        {/* Title */}
        <div className="text-center mb-12 mt-10 w-full max-w-6xl">
          <h1 className="text-5xl font-bold text-white mb-4">
            Centralized Management System
          </h1>
          <p className="text-xl text-gray-300">Select your platform to continue</p>
        </div>

        {/* Platform cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 w-full max-w-6xl">
          {platforms.map((platform) => (
            <button
              key={platform.id}
              onClick={() => onSelectPlatform(platform.id)}
              className="group relative bg-white rounded-2xl p-8 shadow-2xl transform hover:scale-105 transition-all duration-300"
            >
              <div
                className={`absolute inset-0 bg-gradient-to-br ${platform.color} opacity-0 group-hover:opacity-10 rounded-2xl transition-opacity duration-300`}
              />
              <div className="relative">
                <div className={`inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br ${platform.color} rounded-xl mb-6 shadow-lg`}>
                  <platform.icon className="text-white" size={40} />
                </div>
                <h2 className="text-3xl font-bold text-gray-800 mb-2">{platform.name}</h2>
                <p className="text-gray-600 mb-6">{platform.description}</p>
                <div className={`inline-flex items-center text-transparent bg-gradient-to-r ${platform.color} bg-clip-text font-semibold gap-2 group-hover:gap-3 transition-all`}>
                  Continue
                  <span className="transform group-hover:translate-x-1 transition-transform">→</span>
                </div>
              </div>
            </button>
          ))}
        </div>

        {/* Live orders summary */}
        <OrdersSummary />

        {/* Footer */}
        <p className="text-gray-400 text-sm mt-12">
          Unified inventory, orders &amp; profitability tracking
        </p>
      </div>
    </div>
  );
}